if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.content = this.querySelectorAll('.announcement');

      this.index = 0;
      this.length = this.content.length;

      if ( this.length > 1 ) {

        this.querySelectorAll('.announcement-bar__content-nav--left').forEach(button => {
          button.addEventListener('click', () => {
            this.changeSlide(-1);
            this.startAutoRotate();
          });
        });
        this.querySelectorAll('.announcement-bar__content-nav--right').forEach(button => {
          button.addEventListener('click', () => {
            this.changeSlide(1);
            this.startAutoRotate();
          });
        });

        this.startAutoRotate();

      }

    }

    changeSlide(direction = 1) {
      this.content[this.index].classList.remove('is-active');
      this.index = (this.index + direction + this.length) % this.length;
      this.content[this.index].classList.add('is-active');
    }

    startAutoRotate() {
      clearInterval(this.autoRotateInterval);
      this.autoRotateInterval = setInterval(() => {
        this.changeSlide();
      }, 5000);
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}
